/** A/B experiments */
export enum Experiment {

  /** Hypothesis: If we show percentage in the current sales circle, hover amount will decrease.
   * Events:
   *  SalesCurrentCircleHover
  */
  SALES_75 = 'sales-75',
}

export const ALL_EXPERIMENTS: Experiment[] = Object.keys(Experiment).map(key => Experiment[key]);

